import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What age can my child start?',
  answer: 'We welcome students as young as 3 in our Early Skillz program. Classes are grouped by age so every child trains with peers at a similar developmental stage.'
}, {
  question: 'Do I need any experience to join as an adult?',
  answer: 'Not at all. Most of our adult students started with zero martial arts background. Our instructors meet you where you are and help you progress at your own pace.'
}, {
  question: 'What is the Spectrum Skillz program?',
  answer: 'Spectrum Skillz is a specialized martial arts program designed for neurodiverse children. Classes are structured with patience, consistency, and celebration of every milestone.'
}, {
  question: 'How does the free trial week work?',
  answer: 'Just contact us to schedule your first class. You and your child can attend a full week of classes with no commitment and no payment required.'
}, {
  question: 'What should we wear to the first class?',
  answer: 'Comfortable athletic clothing is perfect for your first visit. If you decide to continue, we will help you get set up with a uniform.'
}, {
  question: 'Where exactly are you located?',
  answer: 'Our academy is at 750 Grapevine Hwy in Hurst, TX — just minutes from Colleyville, Bedford, Euless, and North Richland Hills.'
}, {
  question: 'Do you offer birthday parties?',
  answer: 'Yes! We offer three birthday party packages starting at $299 — all include a 2-hour party, pizza and drinks, games and prizes, a martial arts class, and the birthday child gets to break a real board. Visit our Birthday Parties page to see our Basic, Extreme, and Deluxe packages, or call 817-581-1419 to book.'
}];
export function FAQ() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 md:py-28 bg-warm-100" data-id="element-126">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" ref={ref} data-id="element-127">
        <motion.div className="text-center mb-12 md:mb-16" initial={{
        opacity: 0,
        y: 24
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} data-id="element-128">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-navy-950 font-heading tracking-tight" data-id="element-129">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-ink-muted leading-relaxed" data-id="element-130">
            Everything you need to know before getting started.
          </p>
        </motion.div>

        <motion.div className="bg-white rounded-2xl border border-warm-200 overflow-hidden shadow-sm" initial={{
        opacity: 0,
        y: 24
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-131">
          {faqs.map((faq, index) => <div key={index} className={`border-b border-warm-200 last:border-b-0`} data-id="element-132">
              <button className="w-full flex items-center justify-between px-6 py-5 text-left focus:outline-none focus-visible:bg-warm-50 transition-colors hover:bg-warm-50" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} data-id="element-133">
                <span className="text-base font-bold text-navy-950 pr-4" data-id="element-134">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-amber-dark shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-135" />
              </button>
              <AnimatePresence initial={false} data-id="element-136">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-137">
                    <div className="px-6 pb-5 text-ink-muted text-sm leading-relaxed" data-id="element-138">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </motion.div>
      </div>
    </section>;
}